import API from "shared/services/Api";
import { IDiagnosis, IDiagnosisResponse } from "shared/types/Diagnosis";

export const postDiagnosis = async (
  data: IDiagnosis
): Promise<IDiagnosisResponse> => API.post(`oc/diagnosis`, data);
